import { useEffect, useState } from 'react';

const useServiceWorkerUpdate = () => {
	const [updateAvailable, setUpdateAvailable] = useState(false);

	useEffect(() => {
		const onControllerChange = () => {
			setUpdateAvailable(true);
		};

		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
		}

		return () => {
			// Cleanup: Listener entfernen, wenn der Hook nicht mehr genutzt wird
			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
			}
		};
	}, []);

	const reloadPage = () => {
		window.location.reload();
	};

	return { updateAvailable, reloadPage };
};

export default useServiceWorkerUpdate;
